/*
Ensure this is kept up to date with aven_backend (src/entityHelper/loanApplicationHelper.ts) and python (experiments/extendedLines/extendedLinesPolicies.py)
 */
export enum EXTENDED_LINE_POLICY {
    OneFiftyKPolicy = 'OneFiftyKPolicy',
    TwoHundredKPolicy = 'TwoHundredKPolicy',
    TwoFiftyKPolicy = 'TwoFiftyKPolicy',
}
export const EXTENDED_LINES_POLICY_NAMES: string[] = Object.values(EXTENDED_LINE_POLICY)
